/* eslint-disable @typescript-eslint/prefer-for-of */

// Validador para el input de tipo Nif
// Este validador comprobará que el input introducido es un Nif (Identificador personal), caso España(letra detras): 23432345V

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { convertToNumber } from '@frontend/common/utils';

export class NifValidators {
    public static readonly validators = {
        AE: {
            regExp: /^(\d{15})$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        AM: {
            regExp: /^\d{9}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        AT: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        AU: {
            regExp: /^\d{9}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        BE: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        BG: {
            regExp: /^\d{10}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        BH: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        CA: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        CH: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        CN: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        CY: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        CZ: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        DE: {
            regExp: /^([A-Za-z]{2})?\d{9}$/,
            parse(result) {
                return {
                    nif: result?.input ? result.input : null,
                    isValid: this.validator,
                };
            },
            validator() {
                /*
                 *
                 * Format:
                 * N(1-8)+C(1)
                 * N(1-8)>0
                 *
                 * Control:
                 * S=0
                 * FOR I=1 TO 8
                 * S=2*((N(I)+S+9)%10+1)%11
                 * NEXT I
                 * C(1)=11-S; if C(1)=10, C(1)=0
                 */

                if (!this.nif) {
                    return false;
                }

                let nifTemp = this.nif.toUpperCase();
                const nifCountry = nifTemp.substring(0, 2);

                if (nifCountry === 'DE') {
                    nifTemp = nifTemp.substring(2);
                }

                if (nifTemp.length !== 9) {
                    return false;
                }

                if (Number(nifTemp.substring(0, 8)) <= 0) {
                    return false;
                }

                let s = 0;
                for (let i = 1; i <= 8; i++) {
                    s = 2 * ((Number(nifTemp[i - 1]) + s + 9) % 10 + 1) % 11;
                }
                const t = Number(nifTemp[8]);
                s = 11 - s;

                // eslint-disable-next-line eqeqeq
                return t == 0 && s == 10 || t < 10 && t == s;
            },
        },
        DK: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        EG: {
            regExp: /^\d{14}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        EE: {
            regExp: /^(EE)?\d{9}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        ES: {
            regExp: /^(([X-Z])(\d{7})([A-Z])|(\d{8})([A-Z]))$/,
            parse(result) {
                const nieMap = {
                    X: 0,
                    Y: 1,
                    Z: 2,
                };
                return {
                    number: result[0],

                    controlNumber: result[5] || nieMap[result[2]] + result[3],
                    controlKey: result[6] || result[4],
                    isValid: this.validator,
                };
            },
            validator() {
                // eslint-disable-next-line no-secrets/no-secrets
                return 'TRWAGMYFPDXBNJZSQVHLCKE'.charAt(this.controlNumber % 23) === this.controlKey;
            },
        },
        FI: {
            regExp: /^([A-Za-z]{2})?\d{8}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        FR: {
            regExp: /^([A-Za-z]{2})?[\dA-Za-z]{11}$/,
            parse(result) {
                return {
                    nif: result?.input ? result.input : null,
                    isValid: this.validator,
                };
            },
            validator() {
                if (!this.nif) {
                    return false;
                }

                let nifTemp = this.nif.toUpperCase();
                const nifCountry = nifTemp.substring(0, 2);

                if (nifCountry === 'FR') {
                    nifTemp = nifTemp.substring(2);
                }

                if (nifTemp.length !== 11) {
                    return false;
                }

                if (Number.isFinite(Number(nifTemp[0])) && Number.isFinite(Number(nifTemp[1]))) {
                    /*
                     * Old system
                     *
                     * Format:
                     * C(1-2)+N(1-9)
                     * N(1-9)>0
                     *
                     * Control:
                     * C(1-2)=(N(1-9)*100+12)%97
                     */

                    if (!NifValidators.checkAllDigits(nifTemp)) {
                        return false;
                    }

                    const x = Number(nifTemp.substring(0, 2));
                    const y = Number(nifTemp.substring(2, 11));

                    if (y <= 0) {
                        return false;
                    }

                    const s = (y * 100 + 12) % 97;

                    // eslint-disable-next-line eqeqeq
                    return s == x;
                }
                /*
                     * New system.
                     *
                     * Format:
                     * C(1-2)+N(1-9)
                     * N(1-9)>0
                     * C(1-2)={A-H,J-N,P-Z} | {0-9}
                     * si C(1) es alfabetico, C(2) ha de ser numerico y al reves.
                     *
                     * Control:
                     * C{0-9,A-H,J-N,P-Z} ? C{0-33}
                     * si C(1)<10, S=C(1)*24+C(2)-10
                     * si C(1)>9, S=C(1)*34+C(2)-100
                     * X=S%11
                     * S=S\11+1
                     * Y=(N(1-9)+S)%11
                     * si X=Y, correcto
                     */

                /**
                     * Check if a char is a valid nif char
                     *
                     * Valid chars: {A-H,J-N,P-Z}.
                     *
                     * @param char
                     * @return
                     */
                const checkNifFrValidChar = (c) => {
                    const charNifFrancia = [
                        'A',
                        'B',
                        'C',
                        'D',
                        'E',
                        'F',
                        'G',
                        'H',
                        'J',
                        'K',
                        'L',
                        'M',
                        'N',
                        'P',
                        'Q',
                        'R',
                        'S',
                        'T',
                        'U',
                        'V',
                        'W',
                        'Y',
                        'Z',
                    ];

                    if (!c) {
                        return false;
                    }

                    return charNifFrancia.includes(c.toUpperCase());
                };

                /**
                     *
                     * @param  char
                     * @return
                     */
                const controlDigitFrToNumber = (c) => {
                    const controlDigits = [
                        ['0', 0],
                        ['1', 1],
                        ['2', 2],
                        ['3', 3],
                        ['4', 4],
                        ['5', 5],
                        ['6', 6],
                        ['7', 7],
                        ['8', 8],
                        ['9', 9],
                        ['A', 10],
                        ['B', 11],
                        ['C', 12],
                        ['D', 13],
                        ['E', 14],
                        ['F', 15],
                        ['G', 16],
                        ['H', 17],
                        ['J', 18],
                        ['K', 19],
                        ['L', 20],
                        ['M', 21],
                        ['N', 22],
                        ['P', 23],
                        ['Q', 24],
                        ['R', 25],
                        ['S', 26],
                        ['T', 27],
                        ['U', 28],
                        ['V', 29],
                        ['W', 30],
                        ['X', 31],
                        ['Y', 32],
                        ['Z', 33],
                    ];

                    const upperCaseChar = c.toUpperCase();

                    return controlDigits.find((item) => {
                        return item[0] === upperCaseChar;
                    })[1];
                };

                const [x, y] = nifTemp;

                if (Number.isFinite(Number(x))) {
                    if (Number.isFinite(Number(y))) {
                        return false;
                    }
                    if (!checkNifFrValidChar(y)) {
                        return false;
                    }
                } else {
                    if (!Number.isFinite(Number(y))) {
                        return false;
                    }
                    if (!checkNifFrValidChar(x)) {
                        return false;
                    }
                }

                const z = Number(nifTemp.substring(2, 11));
                const controlDigit1 = convertToNumber(controlDigitFrToNumber(x));
                const controlDigit2 = controlDigitFrToNumber(y);

                let s = 0;
                if (controlDigit1 < 10) {
                    s = +controlDigit1 * 24 + +controlDigit2 - 10;
                } else {
                    s = +controlDigit1 * 34 + +controlDigit2 - 100;
                }
                const result = s % 11;
                s = s / 11 + 1;
                s = (z + s) % 11;

                // eslint-disable-next-line eqeqeq
                return result == s;
            },
        },
        GB: {
            regExp: /^(GB)\d{9}$/,
            parse(result) {
                return {
                    nif: result?.input ? result.input : null,
                    isValid: this.validator,
                };
            },
            validator() {
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                const _this = this;

                if (!this.nif) {
                    return false;
                }

                let nifTemp = this.nif.toUpperCase();
                const nifCountry = nifTemp.substring(0, 2);

                if (nifCountry === 'GB') {
                    nifTemp = nifTemp.substring(2);
                }

                _this.NIF_TYPE_UNKNOWN = -1;
                _this.NIF_TYPE_GB_GOB_DEP = 1;
                _this.NIF_TYPE_GB_SAN_AUT = 2;
                _this.NIF_TYPE_GB_STANDARD = 3;
                _this.NIF_TYPE_GB_COMERCIAL_GROUP = 4;
                _this.NIF_TYPE_GB_ISLE_OF_MAN = 5;
                _this.NIF_TYPE_GB_ISLE_OF_MAN_COMERCIAL_GROUP = 6;

                // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
                function checkNifTypeGB(nif) {
                    switch (nif.length) {
                        case 5:
                            // eslint-disable-next-line no-case-declarations
                            const x = nif.charAt(0);
                            // eslint-disable-next-line no-case-declarations
                            const y = nif.charAt(1);

                            if (x === 'G' && y === 'D') {
                                return _this.NIF_TYPE_GB_GOB_DEP;
                            }
                            if (x === 'H' && y === 'A') {
                                return _this.NIF_TYPE_GB_SAN_AUT;
                            }
                            return _this.NIF_TYPE_UNKNOWN;
                        case 9:
                            return _this.NIF_TYPE_GB_STANDARD;
                        case 10:
                            return _this.NIF_TYPE_GB_COMERCIAL_GROUP;
                        case 12:
                            return _this.NIF_TYPE_GB_ISLE_OF_MAN;
                        case 13:
                            return _this.NIF_TYPE_GB_ISLE_OF_MAN_COMERCIAL_GROUP;
                        default:
                            return _this.NIF_TYPE_UNKNOWN;
                    }
                }

                /**
                 * Gob dep
                 *
                 * Format:
                 * A(1-2)+N(1-3)
                 * A(1-2)={GD}
                 * N(1-3)<500
                 */
                // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
                function checkNifGBGobDep(nif) {
                    if (nif.length !== 5) {
                        return false;
                    }

                    // eslint-disable-next-line eqeqeq
                    if (nif[0] != 'G' || nif[1] != 'D') {
                        return false;
                    }

                    if (!Number.isFinite(Number(nif[2]))
                     || !Number.isFinite(Number(nif[3]))
                     || !Number.isFinite(Number(nif[4]))) {
                        return false;
                    }

                    if (Number(nif.substring(2, 5)) >= 500) {
                        return false;
                    }

                    return true;
                }

                /**
                 * San Aut
                 *
                 * Format:
                 * A(1-2)+N(1-3)
                 * A(1-2)={HA}
                 * N(1-3)>499
                 */
                // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
                function checkNifGBSanAut(nif) {
                    if (nif.length !== 5) {
                        return false;
                    }

                    // eslint-disable-next-line eqeqeq
                    if (nif[0] != 'H' || nif[1] != 'A') {
                        return false;
                    }

                    if (!Number.isFinite(Number(nif[2]))
                    || !Number.isFinite(Number(nif[3]))
                    || !Number.isFinite(Number(nif[4]))) {
                        return false;
                    }

                    if (Number(nif.substring(2, 5)) < 500) {
                        return false;
                    }

                    return true;
                }

                /**
                 * Standard
                 *
                 * Format:
                 * N(1-9)
                 * N(1-7)={0000001-0019999,1000000-9999999}
                 * N(8-9)<97
                 *
                 * Control:
                 * S=8*N(1)+7*N(2)+6*N(3)+5*N(4)+4*N(5)+3*N(6)+2*N(7)+10*N(8)+N(9)
                 * if S%97=0, valid
                 */
                // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
                function checkNifGBStandard(nif) {
                    if (nif.length !== 9) {
                        return false;
                    }

                    if (!NifValidators.checkAllDigits(nif)) {
                        return false;
                    }

                    const x = Number(nif.substring(0, 7));
                    if (x < 0 || x >= 20000 && x < 1000000 || x > 9999999) {
                        return false;
                    }

                    if (Number(nif.substring(7, 9)) >= 97) {
                        return false;
                    }

                    const s = 8 * Number(nif[0])
                        + 7 * Number(nif[1])
                        + 6 * Number(nif[2])
                        + 5 * Number(nif[3])
                        + 4 * Number(nif[4])
                        + 3 * Number(nif[5])
                        + 2 * Number(nif[6])
                        + 10 * Number(nif[7])
                        + Number(nif[8]);

                    return s % 97 === 0;
                }

                /**
                 * Comercial Group
                 *
                 * Format:
                 * N(1-10)
                 * N(1-7)={0000001-0019999,1000000-9999999}
                 * N(8-9)<97
                 * N(10)={3}
                 *
                 * Control:
                 * S=8*N(1)+7*N(2)+6*N(3)+5*N(4)+4*N(5)+3*N(6)+2*N(7)+10*N(8)+N(9)
                 * if S%97=0, valid
                 */
                // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
                function checkNifGBComercialGroup(nif) {
                    if (nif.length !== 10) {
                        return false;
                    }

                    if (!NifValidators.checkAllDigits(nif)) {
                        return false;
                    }

                    const x = Number(nif.substring(0, 7));
                    if (x < 0 || x >= 20000 && x < 1000000 || x > 9999999) {
                        return false;
                    }

                    if (Number(nif.substring(7, 9)) >= 97) {
                        return false;
                    }

                    if (Number(nif[9]) !== 3) {
                        return false;
                    }

                    const s = 8 * Number(nif[0])
                        + 7 * Number(nif[1])
                        + 6 * Number(nif[2])
                        + 5 * Number(nif[3])
                        + 4 * Number(nif[4])
                        + 3 * Number(nif[5])
                        + 2 * Number(nif[6])
                        + 10 * Number(nif[7])
                        + Number(nif[8]);

                    return s % 97 === 0;
                }

                /**
                 * Isle of Man
                 *
                 * Format:
                 * N(1-12)
                 * N(1-3)={000,001}
                 * N(4-10)={0000001-0019999,1000000-9999999}
                 * N(11-12)<97
                 *
                 * Control:
                 * S=8*N(4)+7*N(5)+6*N(6)+5*N(7)+4*N(8)+3*N(9)+2*N(10)+10*N(11)+N(12)
                 * if S%97=0, valid
                 */
                // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
                function checkNifGBIsleOfMan(nif) {
                    if (nif.length !== 12) {
                        return false;
                    }

                    if (!NifValidators.checkAllDigits(nif)) {
                        return false;
                    }

                    const x = Number(nif.substring(0, 3));
                    if (x !== 0 && x !== 1) {
                        return false;
                    }

                    const y = Number(nif.substring(3, 10));
                    if (y < 0 || y >= 20000 && y < 1000000 || y > 9999999) {
                        return false;
                    }

                    if (Number(nif.substring(10, 12)) >= 97) {
                        return false;
                    }

                    const s = 8 * Number(nif[3])
                        + 7 * Number(nif[4])
                        + 6 * Number(nif[5])
                        + 5 * Number(nif[6])
                        + 4 * Number(nif[7])
                        + 3 * Number(nif[8])
                        + 2 * Number(nif[9])
                        + 10 * Number(nif[10])
                        + Number(nif[11]);

                    return s % 97 === 0;
                }

                /**
                 * Comercial Group Isle of Man
                 *
                 * Format:
                 * N(1-13)
                 * N(1-3)={000,001}
                 * N(4-10)={0000001-0019999,1000000-9999999}
                 * N(11-12)<97
                 * N(13)={3}
                 *
                 * Control:
                 * S=8*N(4)+7*N(5)+6*N(6)+5*N(7)+4*N(8)+3*N(9)+2*N(10)+10*N(11)+N(12)
                 * if S%97=0, valid
                 */
                // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
                function checkNifGBIsleOfManComercialGroup(nif) {
                    if (nif.length !== 13) {
                        return false;
                    }

                    if (!NifValidators.checkAllDigits(nif)) {
                        return false;
                    }

                    const x = Number(nif.substring(0, 3));
                    if (x !== 0 && x !== 1) {
                        return false;
                    }

                    const y = Number(nif.substring(3, 10));
                    if (y < 0 || y >= 20000 && y < 1000000 || y > 9999999) {
                        return false;
                    }

                    if (Number(nif.substring(10, 12)) >= 97) {
                        return false;
                    }

                    if (Number(nif[12]) !== 3) {
                        return false;
                    }

                    const s = 8 * Number(nif[3])
                        + 7 * Number(nif[4])
                        + 6 * Number(nif[5])
                        + 5 * Number(nif[6])
                        + 4 * Number(nif[7])
                        + 3 * Number(nif[8])
                        + 2 * Number(nif[9])
                        + 10 * Number(nif[10])
                        + Number(nif[11]);

                    return s % 97 === 0;
                }

                switch (checkNifTypeGB(nifTemp)) {
                    case _this.NIF_TYPE_GB_GOB_DEP:
                        return checkNifGBGobDep(nifTemp);
                    case _this.NIF_TYPE_GB_SAN_AUT:
                        return checkNifGBSanAut(nifTemp);
                    case _this.NIF_TYPE_GB_STANDARD:
                        return checkNifGBStandard(nifTemp);
                    case _this.NIF_TYPE_GB_COMERCIAL_GROUP:
                        return checkNifGBComercialGroup(nifTemp);
                    case _this.NIF_TYPE_GB_ISLE_OF_MAN:
                        return checkNifGBIsleOfMan(nifTemp);
                    case _this.NIF_TYPE_GB_ISLE_OF_MAN_COMERCIAL_GROUP:
                        return checkNifGBIsleOfManComercialGroup(nifTemp);
                    case _this.NIF_TYPE_UNKNOWN:
                        return false;
                    default:
                        return false;
                }
            },
        },
        GE: {
            regExp: /^(\d{9}|\d{11})$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        GR: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        HR: {
            regExp: /^\d{11}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        HU: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        IC: {
            regExp: /^(([X-Z])(\d{7})([A-Z])|(\d{8})([A-Z]))$/,
            parse(result) {
                return {
                    nif: result?.input ? result.input : null,
                    isValid: this.validator,
                };
            },
            validator() {
                if (!this.nif) {
                    return false;
                }

                const validator = NifValidators.validators.ES;
                const result = validator.regExp.exec(this.nif);
                if (result) {
                    return validator.parse(result).isValid();
                }
                return false;
            },
        },
        IE: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        IT: {
            regExp: /^([A-Za-z]{6}[\dL-NP-Vl-np-v]{2}[A-EHLMPR-Ta-ehlmpr-t][\dL-NP-Vl-np-v]{2}[A-Za-z][\dL-NP-Vl-np-v]{3}[A-Za-z])$|^(\d{11})$|^(IT\d{11})$/,
            parse(result) {
                return {
                    number: result[0],
                    controlNumber: result[2],
                    controlKey: result[1],
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        JO: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        JP: {
            regExp: /^([A-Za-z]{2})?\w{14}$/,
            parse(result) {
                return {
                    nif: result?.input ? result.input : null,
                    isValid: this.validator,
                };
            },
            validator() {
                if (!this.nif) {
                    return false;
                }

                let nifTemp = this.nif.toUpperCase();
                const nifCountry = nifTemp.substring(0, 2);

                if (nifCountry === 'JP') {
                    nifTemp = nifTemp.substring(2);
                }

                if (nifTemp.length !== 14) {
                    return false;
                }

                if (
                    !Number.isFinite(Number(nifTemp[0]))
                    || !Number.isFinite(Number(nifTemp[1]))
                    || !Number.isFinite(Number(nifTemp[2]))
                    || !Number.isFinite(Number(nifTemp[3]))
                    || Number.isFinite(Number(nifTemp[4]))
                    || nifTemp[4] !== '_'
                    || !Number.isFinite(Number(nifTemp[5]))
                    || !Number.isFinite(Number(nifTemp[6]))
                    || Number.isFinite(Number(nifTemp[7]))
                    || nifTemp[7] !== '_'
                    || !Number.isFinite(Number(nifTemp[8]))
                    || !Number.isFinite(Number(nifTemp[9]))
                    || !Number.isFinite(Number(nifTemp[10]))
                    || !Number.isFinite(Number(nifTemp[11]))
                    || !Number.isFinite(Number(nifTemp[12]))
                    || !Number.isFinite(Number(nifTemp[13]))
                ) {
                    return false;
                }

                return true;
            },
        },
        KR: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        KZ: {
            regExp: /^\d{12}$/,
            parse(result) {
                return {
                    tin: result?.input ? result.input : null,
                    isValid: this.validator,
                };
            },
            validator() {
                if (!this.tin) {
                    return false;
                }

                const tin = this.tin;

                const digits = tin.split('').map(Number);

                // Calculate the control sum
                let weights = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
                let sum = 0;
                for (let i = 0; i < 10; i++) {
                    sum += digits[i] * weights[i];
                }

                // Calculate the remainder modulo 11
                let remainder = sum % 11;

                // If the remainder is 10, the last digit should be 0
                if (remainder === 10) {
                    weights = [3, 4, 5, 6, 7, 8, 9, 10, 11, 1, 2];
                    sum = 0;
                    for (let i = 0; i < 10; i++) {
                        sum += digits[i] * weights[i];
                    }
                    remainder = sum % 11;
                }

                // Otherwise, the last digit should equal the remainder
                return digits[11] === remainder;
            },
        },
        LB: {
            regExp: /^\d+-601$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        LT: {
            regExp: /^\d{9,12}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        LU: {
            regExp: /^./,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        LV: {
            regExp: /(^LV\d{11}$)|(^\d{11}$)/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        MA: {
            regExp: /^(\d{15})$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        MC: {
            regExp: /^([A-Za-z]{2})?[\dA-Za-z]{11}$/,
            parse(result) {
                return {
                    nif: result?.input ? result.input : null,
                    isValid: this.validator,
                };
            },
            validator() {
                if (!this.nif) {
                    return false;
                }

                let nifTemp = this.nif.toUpperCase();
                const nifCountry = nifTemp.substring(0, 2);

                if (nifCountry === 'MC') {
                    nifTemp = nifTemp.substring(2);
                    const nifTempCountry = nifTemp.substring(0, 2);
                    if (nifTempCountry === 'FR') {
                        return false;
                    }
                }

                const validator = NifValidators.validators.FR;
                const result = validator.regExp.exec(nifTemp);
                if (result) {
                    return validator.parse(result).isValid();
                }
                return false;
            },
        },
        MT: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        MX: {
            regExp: /^((([&A-ZÑ]{4})(\d{2})(0[13578]|1[02])((0[1-9]|[12]\d)|3[01])([\dA-Z]{3}))|(([&A-ZÑ]{4})(\d{2})(0[13-9]|1[0-2])((0[1-9]|[12]\d)|30)([\dA-Z]{3}))|(([&A-ZÑ]{4})([02468][048]|[13579][26])02(0[1-9]|[12]\d)([\dA-Z]{3}))|(([&A-ZÑ]{4})(\d{2})02(0[1-9]|1\d|2[0-8])([\dA-Z]{3})))$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        NL: {
            regExp: /^([A-Za-z]{2})?[\dA-Za-z]{12}$/,
            parse(result) {
                return {
                    nif: result?.input ? result.input : null,
                    isValid: this.validator,
                };
            },
            validator() {
                /**
                 * Format:
                 * N(1-8)+C(1)+A(1)+N(9-10)
                 * N(1-8)>0
                 * A(1)={B}
                 *
                 * Control:
                 * S=9*N(1)+8*N(2)+7*N(3)+6*N(4)+5*N(5)+4*N(6)+3*N(7)+2*N(8)
                 * C(1)=S%11; if C(1)=10, invalid.
                 */
                if (!this.nif) {
                    return false;
                }

                let nifTemp = this.nif.toUpperCase();
                const nifCountry = nifTemp.substring(0, 2);

                if (nifCountry === 'NL') {
                    nifTemp = nifTemp.substring(2);
                }

                if (nifTemp.length !== 12) {
                    return false;
                }

                if (
                    !Number.isFinite(Number(nifTemp[0]))
                    || !Number.isFinite(Number(nifTemp[1]))
                    || !Number.isFinite(Number(nifTemp[2]))
                    || !Number.isFinite(Number(nifTemp[3]))
                    || !Number.isFinite(Number(nifTemp[4]))
                    || !Number.isFinite(Number(nifTemp[5]))
                    || !Number.isFinite(Number(nifTemp[6]))
                    || !Number.isFinite(Number(nifTemp[7]))
                    || !Number.isFinite(Number(nifTemp[10]))
                    || !Number.isFinite(Number(nifTemp[11]))
                ) {
                    return false;
                }

                if (nifTemp[9] !== 'B') {
                    return false;
                }

                const x = Number(nifTemp.substring(0, 8));
                if (x <= 0) {
                    return false;
                }

                let s = 9 * Number(nifTemp[0])
                    + 8 * Number(nifTemp[1])
                    + 7 * Number(nifTemp[2])
                    + 6 * Number(nifTemp[3])
                    + 5 * Number(nifTemp[4])
                    + 4 * Number(nifTemp[5])
                    + 3 * Number(nifTemp[6])
                    + 2 * Number(nifTemp[7]);

                s = s % 11;

                return s !== 10 && s === Number(Number(nifTemp[8]));
            },
        },
        NO: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        PL: {
            regExp: /^\d{10}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        PT: {
            regExp: /^([A-Za-z]{2})?\d{9}$/,
            parse(result) {
                return {
                    nif: result?.input ? result.input : null,
                    isValid: this.validator,
                };
            },
            validator() {
                /**
                 * Format:
                 * N(1-8)+C(1)
                 * N(1)>0
                 *
                 * Control:
                 * S=9*N(1)+8*N(2)+7*N(3)+6*N(4)+5*N(5)+4*N(6)+3*N(7)+2*N(8)
                 * C(1)=11-S%11; si C(1)=10, C(1)=0; si C(1)=11, C(1)=0
                 */
                if (!this.nif) {
                    return false;
                }

                let nifTemp = this.nif.toUpperCase();
                const nifCountry = nifTemp.substring(0, 2);

                if (nifCountry === 'PT') {
                    nifTemp = nifTemp.substring(2);
                }

                if (nifTemp.length !== 9) {
                    return false;
                }

                if (!NifValidators.checkAllDigits(nifTemp)) {
                    return false;
                }

                if (Number(nifTemp[0]) <= 0) {
                    return false;
                }

                let s = 9 * Number(nifTemp[0])
                    + 8 * Number(nifTemp[1])
                    + 7 * Number(nifTemp[2])
                    + 6 * Number(nifTemp[3])
                    + 5 * Number(nifTemp[4])
                    + 4 * Number(nifTemp[5])
                    + 3 * Number(nifTemp[6])
                    + 2 * Number(nifTemp[7]);

                s = 11 - s % 11;

                return Number(nifTemp[8]) === s || Number(nifTemp[8]) === 0 && (s === 10 || s === 11);
            },
        },
        QA: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        RO: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        RU: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        SA: {
            regExp: /^(\d{15})$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        SE: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        SI: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        SK: {
            regExp: /^.{1,20}$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        TR: {
            regExp: /^(\d{11})$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        TW: {
            regExp: /^(\d{8})$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        UA: {
            regExp: /^\d{10}$/, // Formato abierto
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
            validator() {
                return true;
            },
        },
        US: {
            regExp: /^.{1,20}$/, // Formato abierto
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
        XK: {
            regExp: /^(\d{9})$/,
            parse() {
                return {
                    isValid: this.validator,
                };
            },
            validator: () => true,
        },
    };

    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    static createValidator(countryCode: string): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (countryCode == null) {
                return;
            }

            const validator = this.validators[countryCode];

            const input = control.value?.toString();

            const result = validator.regExp.exec(input);

            if (result && validator.parse(result).isValid()) {
                return;
            }
            return { pattern: true };
        };
    }

    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    static checkAllDigits(a) {
        for (let i = 0; i < a.length; i++) {
            if (!Number.isFinite(Number(a[i]))) {
                return false;
            }
        }
        return true;
    }

    /**
     * Multiplies two numbers smaller than or equal to 9 and returns the sum of the digits of the result.
     * Ex: 2*6 = 12 -> 1 + 2 = 3. -> 2#6 = 3
     *
     * @param a the a
     * @param b the b
     * @return the int
     */
    private getSostenido(a, b) {
        let i = 0;
        const r = Number(a * b);
        const re = r.toString();
        const j = Number(re[0]);
        if (parseInt(r.toString()) > 9) {
            i = Number(re[1]);
        }
        return j + i;
    }
}
